import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  // Links das redes sociais
  const socialLinks = {
    instagram: "https://www.instagram.com/criaappoficial/",
    youtube: "https://www.youtube.com/@Criaapp-oficial",
    linkedin: "https://www.linkedin.com/company/criaapp/?viewAsMember=true"
  };

  // Função para abrir links externos
  const openExternalLink = (url) => {
    window.open(url, '_blank');
  };

  // Função para navegar para páginas internas
  const navigateToPage = (path) => {
    navigate(path);
  };

  // Função para abrir WhatsApp
  const openWhatsApp = () => {
    const phoneNumber = "5582996992182"; // ATUALIZE COM SEU NÚMERO REAL
    const message = "Olá! Gostaria de mais informações sobre como transformar meu site em aplicativo.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // Função para scroll suave para seções
  const scrollToSection = (sectionId) => {
    if (window.location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <footer className="bg-[#111111] text-[#A1A1AA] pt-12 pb-6 font-sans">
      <div className="container mx-auto px-6 max-w-5xl">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-8 mb-16">
          
          {/* Produto */}
          <div>
            <h4 className="text-[13px] font-medium text-white mb-3">Produto</h4>
            <ul className="space-y-2">
              {[
                { name: 'Recursos', id: 'features' },
                { name: 'Como Funciona', id: 'process' },
                { name: 'Clientes', id: 'clientes' },
                { name: 'FAQ', id: 'faq' }
              ].map((item, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-[13px] hover:text-white transition-colors duration-200"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Suporte */}
          <div>
            <h4 className="text-[13px] font-medium text-white mb-3">Suporte</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => navigateToPage('/status-do-sistema')} className="text-[13px] hover:text-white transition-colors duration-200">
                  Status do Sistema
                </button>
              </li>
              <li>
                <button onClick={() => navigateToPage('/central-ajuda')} className="text-[13px] hover:text-white transition-colors duration-200">
                  Central de Ajuda
                </button>
              </li>
              <li>
                <button onClick={openWhatsApp} className="text-[13px] hover:text-white transition-colors duration-200">
                  Contato WhatsApp
                </button>
              </li>
            </ul>
          </div>

          {/* Jurídico */}
          <div>
            <h4 className="text-[13px] font-medium text-white mb-3">Jurídico</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => navigateToPage('/termos-de-uso')} className="text-[13px] hover:text-white transition-colors duration-200">
                  Termos de Serviço
                </button>
              </li>
              <li>
                <button onClick={() => navigateToPage('/politica-de-privacidade')} className="text-[13px] hover:text-white transition-colors duration-200">
                  Política de Privacidade
                </button>
              </li>
            </ul>
          </div>

          {/* Conectar */}
          <div>
            <h4 className="text-[13px] font-medium text-white mb-3">Conectar</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => openExternalLink(socialLinks.instagram)} className="text-[13px] hover:text-white transition-colors duration-200">
                  Instagram
                </button>
              </li>
              <li>
                <button onClick={() => openExternalLink(socialLinks.youtube)} className="text-[13px] hover:text-white transition-colors duration-200">
                  YouTube
                </button>
              </li>
              <li>
                <button onClick={() => openExternalLink(socialLinks.linkedin)} className="text-[13px] hover:text-white transition-colors duration-200">
                  LinkedIn
                </button>
              </li>
            </ul>
          </div>

        </div>

        {/* Rodapé Inferior */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[13px]">
          <div className="flex items-center gap-4">
            <span>&copy; {new Date().getFullYear()} CriaApp.</span>
          </div>
          
          <div className="flex items-center gap-4">
            <span className="flex items-center">
              Desenvolvido com <span className="mx-1.5 text-white/30 text-xs">🤍</span> para você
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;